import { ReviewCommentStatusCounts } from '../../services/platformApi';

export interface ProjectEditorState {
  title: string;
  description: string;
  status: string;
  storyType: string;
  packageType: string;
  language: string;
}

export interface ArtifactFormState {
  artifactType: string;
  title: string;
  description: string;
  textContent: string;
  externalUrl: string;
  uploaderUserId: string;
  interviewSessionId: string;
}

export interface InterviewSessionFormState {
  title: string;
  interviewType: 'audio' | 'video';
  interviewerName: string;
  intervieweeName: string;
  scheduledAt: string;
  maxDuration: string;
  notes: string;
  meetingLink: string;
}

export interface TranscriptFormState {
  interviewSessionId: string;
  sourceArtifactId: string;
  language: string;
  confidence: string;
  text: string;
}

export interface StoryOutlineFormState {
  sourceTranscriptId: string;
  title: string;
  summary: string;
  language: string;
  outlineJson: string;
}

export interface StoryChapterFormState {
  outlineId: string;
  title: string;
  bodyText: string;
  language: string;
  orderIndex: string;
}

export interface ReviewCommentFormState {
  targetType: string;
  targetId: string;
  authorType: 'user' | 'ai';
  authorUserId: string;
  anchorText: string;
  anchorStart: string;
  anchorEnd: string;
  commentText: string;
}

export interface ReviewRequestFormState {
  targetType: string;
  targetId: string;
  reviewerId: string;
  title: string;
  content: string;
}

export const initialArtifactForm: ArtifactFormState = {
  artifactType: 'audio',
  title: '',
  description: '',
  textContent: '',
  externalUrl: '',
  uploaderUserId: '',
  interviewSessionId: '',
};

export const initialInterviewSessionForm: InterviewSessionFormState = {
  title: '',
  interviewType: 'audio',
  interviewerName: '',
  intervieweeName: '',
  scheduledAt: '',
  maxDuration: '60',
  notes: '',
  meetingLink: '',
};

export const initialTranscriptForm: TranscriptFormState = {
  interviewSessionId: '',
  sourceArtifactId: '',
  language: 'en',
  confidence: '',
  text: '',
};

export const initialStoryOutlineForm: StoryOutlineFormState = {
  sourceTranscriptId: '',
  title: '',
  summary: '',
  language: 'en',
  outlineJson: '',
};

export const initialStoryChapterForm: StoryChapterFormState = {
  outlineId: '',
  title: '',
  bodyText: '',
  language: 'en',
  orderIndex: '1',
};

export const initialReviewCommentForm: ReviewCommentFormState = {
  targetType: 'story_chapter',
  targetId: '',
  authorType: 'user',
  authorUserId: '',
  anchorText: '',
  anchorStart: '',
  anchorEnd: '',
  commentText: '',
};

export const initialReviewRequestForm: ReviewRequestFormState = {
  targetType: 'story_chapter',
  targetId: '',
  reviewerId: '',
  title: '',
  content: '',
};

export const initialReviewCommentStatusCounts: ReviewCommentStatusCounts = {
  total: 0,
  open: 0,
  resolved: 0,
  dismissed: 0,
};
